import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-522b7ab7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "events-log" }
const _hoisted_2 = { class: "events-log__item-date" }
const _hoisted_3 = { class: "events-log__item-line" }
const _hoisted_4 = {
  key: 0,
  class: "i"
}
const _hoisted_5 = { class: "events-log__item-content" }
const _hoisted_6 = { class: "events-log__content-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "events-log__content-desc" }
const _hoisted_10 = {
  key: 0,
  class: "content-desc__reason"
}
const _hoisted_11 = {
  key: 1,
  class: "content-desc__reason"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: "content-desc__opt-user"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "content-desc__line" }, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "content-desc__reason"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "content-desc__reason"
}
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (log, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "events-log__item",
        key: log.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", null, _toDisplayString(_ctx.moment("20" + log.opt_time_name).format("HH:mm")), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.moment("20" + log.opt_time_name).format("YY-MM-DD")), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("b", {
            class: _normalizeClass({ first: index == 0 })
          }, null, 2),
          (index != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                size: "14",
                color: "#3d6eeb",
                name: "checked"
              })),
          _createElementVNode("span", {
            class: _normalizeClass({ last: index == _ctx.state.list.length - 1 })
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (log.opt_uid_array.length > 0)
              ? (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(log.opt_uid_array[0].department_name) + " - " + _toDisplayString(log.opt_uid_array[0].name), 1))
              : _createCommentVNode("", true),
            (log.show_content)
              ? (_openBlock(), _createElementBlock("b", _hoisted_8, _toDisplayString(log.show_content), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (log.opt_content)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "备注：" + _toDisplayString(log.opt_content), 1))
              : _createCommentVNode("", true),
            (log.pic_ids_array.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (_ctx.ImagePreview(log.pic_ids_array.map(pic => pic.photo_file)))
                  }, "查看图片", 8, _hoisted_12)
                ]))
              : _createCommentVNode("", true),
            ((log.opt_type == 6 || log.opt_type == 12) && log.obj_uids_array.length > 0)
              ? (_openBlock(), _createElementBlock("i", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.obj_uids_array, (user, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: user.id
                    }, [
                      _createTextVNode(_toDisplayString(user.department_name) + " - " + _toDisplayString(user.name) + " ", 1),
                      (index != log.obj_uids_array.length - 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(",")
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (log.opt_type == 7 || log.opt_type == 8)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _hoisted_14,
                  (log.opt_type == 8)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createTextVNode(" 转审批，审批编号： "),
                        (log.approval_array?.length > 0)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              onClick: ($event: any) => (
                    _ctx.$router.push({
                      name: _ctx.$RouterName.APPROVAL_DETAIL,
                      params: {
                        id: log.approval_array[0].id
                      }
                    })
                  )
                            }, _toDisplayString(log.approval_array[0].code), 9, _hoisted_16))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (log.opt_type == 7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createTextVNode(" 转工单，工单编号： "),
                        (log.workorder_array?.length > 0)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.toGuaranteeDetil(log.workorder_array[0].id))
                            }, _toDisplayString(log.workorder_array[0].orderid), 9, _hoisted_18))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128))
  ]))
}